import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState, useRef} from "react";
import {
    checkPermission, getDOYOptions,
    getStockholderPositions,
    isEmpty,
    recalculateStockHolders, stockHolderPercentageDiff,
    validateAFM
} from "../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import axios from "axios";
import {fetchCompanyDetails, fetchCompanyInstallations} from "../../../../_apis/api";
import {setCompanyDetails, setCompanyInstallations} from "../../../../_reducers/companySlice";
import {Button, Col, Form, Modal, Row, Spinner} from "react-bootstrap";
import Input from "../../../common/Input";
import Checkbox from "../../../common/CheckBox";
import EditableTable from "../../../primer/Editable-Table";
import Dropdown from "../../../primer/Dropdown";
import "./styles/company-settings.css";
import moment from "moment";
import {FaSave} from "react-icons/fa";
import {useTranslation} from "../../../../hooks/useTranslation";

const BULLET_CHAR = "•";

const SecureMaskedPasswordInput = ({
                                       value = "",
                                       onChange,
                                       placeholder = "Password",
                                       disabled = false,
                                       size = "sm"
                                   }) => {
    const inputRef = useRef(null);
    const maskedDisplayValue = BULLET_CHAR.repeat(value.length);

    const handleKeyDown = (e) => {
        const input = inputRef.current;
        if (!input) return;

        const { selectionStart, selectionEnd } = input;

        if (e.key === "Backspace") {
            e.preventDefault();
            if (selectionStart !== selectionEnd) {
                const nextVal = value.slice(0, selectionStart) + value.slice(selectionEnd);
                onChange(nextVal);
                setTimeout(() => input.setSelectionRange(selectionStart, selectionStart), 0);
            } else if (selectionStart > 0) {
                const nextVal = value.slice(0, selectionStart - 1) + value.slice(selectionStart);
                onChange(nextVal);
                setTimeout(() => input.setSelectionRange(selectionStart - 1, selectionStart - 1), 0);
            }
        } else if (e.key === "Delete") {
            e.preventDefault();
            if (selectionStart !== selectionEnd) {
                const nextVal = value.slice(0, selectionStart) + value.slice(selectionEnd);
                onChange(nextVal);
                setTimeout(() => input.setSelectionRange(selectionStart, selectionStart), 0);
            } else if (selectionStart < value.length) {
                const nextVal = value.slice(0, selectionStart) + value.slice(selectionStart + 1);
                onChange(nextVal);
                setTimeout(() => input.setSelectionRange(selectionStart, selectionStart), 0);
            }
        }
    };

    const handleBeforeInput = (e) => {
        if (e.data) {
            e.preventDefault();
            const input = inputRef.current;
            const { selectionStart, selectionEnd } = input;
            const nextVal = value.slice(0, selectionStart) + e.data + value.slice(selectionEnd);
            const nextCursor = selectionStart + e.data.length;
            onChange(nextVal);
            setTimeout(() => input.setSelectionRange(nextCursor, nextCursor), 0);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData("text");
        if (!pastedText) return;

        const input = inputRef.current;
        const { selectionStart, selectionEnd } = input;
        const nextVal = value.slice(0, selectionStart) + pastedText + value.slice(selectionEnd);
        const nextCursor = selectionStart + pastedText.length;
        onChange(nextVal);
        setTimeout(() => input.setSelectionRange(nextCursor, nextCursor), 0);
    };

    return (
        <Form.Control
            ref={inputRef}
            size={size}
            type="password"
            autoComplete="new-password"
            placeholder={placeholder}
            value={maskedDisplayValue}
            onKeyDown={handleKeyDown}
            onBeforeInput={handleBeforeInput}
            onPaste={handlePaste}
            onChange={() => {}}
            disabled={disabled}
        />
    );
};

const CompanySettings = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const installations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const companyDetails = useSelector(state => state.COMPANY_DATA.companyDetails);
    const [companyData, setCompanyData] = useState({});
    const [userDataIncrKey, setUserDataIncrKey] = useState(0);
    const [userData, setUserData] = useState([]);
    const imgData = companyDetails.companyLogo || "";
    const [useLogo = companyDetails.useLogo !== undefined && companyDetails.useLogo !== "" ? companyDetails.useLogo : "inactive", setUseLogo] = useState();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const [companyCredsLoading, setCompanyCredsLoading] = useState(false);
    const [companyCredsFetching, setCompanyCredsFetching] = useState(false);
    const [companyCredentials, setCompanyCredentials] = useState({
        username: "",
        password: ""
    });

    const [accountantCredsLoading, setAccountantCredsLoading] = useState(false);
    const [accountantCredsFetching, setAccountantCredsFetching] = useState(false);
    const [accountantCredentials, setAccountantCredentials] = useState({
        username: "",
        password: "",
        isAccountant: false,
        accountantAfm: ""
    });

    const initNewInstallation = {
        vatNumber: company.vatNumber,
        type: "Κεντρικό",
        installationMasterId: "0",
        companyId: company.id,
        doy: "",
        country: "GR",
        address: "",
        city: "",
        isActive: "active",
        postalCode: "",
        phone: "",
        installationAccounting: "",
    };
    const [newInstallation, setNewInstallation] = useState({...initNewInstallation});
    const [newInstallationLoading, setNewInstallationLoading] = useState(false);
    const [showNewInstallationModal, setShowNewInstallationModal] = useState(false);

    const [editInstallation, setEditInstallation] = useState({});
    const [editInstallationLoading, setEditInstallationLoading] = useState(false);
    const [showEditInstallationModal, setShowEditInstallationModal] = useState(false);

    const [installationOptions, setInstallationOptions] = useState([]);

    useEffect(() => {
        if (installationOptions.length === 0) {
            let tOpt = [{label: "Κεντρικό", value: "0"}];
            for (let i = 1; i <= 25; i++) {
                tOpt.push({label: `Υποκατάστημα ${i}`, value: String(i)});
            }
            setInstallationOptions(tOpt);
        }
    }, []);

    const activityOptions = [
        {value: "active", label: "Ενεργή"},
        {value: "inactive", label: "Ανενεργή"}
    ];

    const stockHoldersTableColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
        },
        {
            name: "Όνομα",
            field: "name",
            editable: true,
            required: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Επώνυμο",
            field: "surname",
            editable: true,
            required: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "ΑΦΜ",
            field: "vat",
            editable: true,
            required: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Θέση",
            field: "position",
            width: '120px',
            editable: true,
            required: true,
            inputType: {
                options: getStockholderPositions(),
                type: 'dropdown',
            }
        },
        {
            name: "Ποσοστό %",
            field: "percentage",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
            }
        },
        {
            name: "Συνολική Αξία μετοχών",
            field: "stockValue",
            editable: false,
            disabled: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 7,
                }
            }
        },
        {
            name: "Ημ/νια από",
            field: "dateFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true"
            }
        },
        {
            name: "Ημ/νια έως",
            field: "dateTo",
            editable: true,
            inputType: {
                type: 'datebox',
                allowOtherYears: "true"
            }
        },
        {
            name: "Κατάσταση",
            field: "isActive",
            editable: true,
            required: true,
            width: "15%",
            inputType: {
                type: "select",
                options: [{label: "Ενεργός", value: "true"}, {label: "Ανενεργός", value: "false"}]
            }
        }
    ];

    const uploadCompanyLogo = (e) => {
        const file = e.target.files[0];
        if (!file) {
            return toast.info("Παρακαλώ επιλέξτε ένα αρχείο.");
        } else {
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!validTypes.includes(file.type)) return toast.info("Υποστηρίζονται μόνο αρχεία της μορφής .png .jpg και .jpeg .");
            if (file.size > 75 * 1024) return toast.info("Το αρχείο πρέπει να είναι μικρότερο από 75 kb.");

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.width !== 350 || img.height !== 100) return toast.info('Image must be exactly 350 x 100 pixels.');

                    const base64Data = e.target.result;

                    axios.post(`${process.env.REACT_APP_API_URL2}/company/uploadCompanyLogo`, {
                        company: company.id,
                        logo: base64Data
                    }, {
                        headers: {"Content-Type": "application/json"},
                    }).then((res) => {
                        if (res.data.status === "200") {
                            toast.success("Επιτυχής μεταφόρτωση λογοτύπου εταιρείας.");
                            dispatch(fetchCompanyDetails(company.id));
                        } else {
                            toast.error(res.data.message);
                        }
                    }).catch((err) => {
                        console.log(err);
                        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                    });
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUseLogo = (e) => {
        let requestData = {
            useLogo: e.target.value.toString(),
            company: company.id
        };
        axios.post(`${process.env.REACT_APP_API_URL2}/company/uploadCompanyLogo`, requestData)
            .then((res) => {
                if (res.data.status === "200") {
                    toast.success("Company Logo Usage was updated successfully");
                    dispatch(fetchCompanyDetails(company.id));
                    setUseLogo(e.target.value);
                } else {
                    setUseLogo("inactive");
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                setUseLogo("inactive");
                toast.error(error);
            });
    };

    useEffect(() => {
        fetchUsers();
        fetchCompanyData();
    }, []);

    useEffect(() => {
        if (company?.id) {
            fetchCompanyTaxisCredentials();
            fetchAccountantTaxisCredentials();
        }
    }, [company?.id]);

    useEffect(() => {
        if (userData) {
            setUserDataIncrKey(userDataIncrKey + 1);
        }
    }, [userData]);

    const fetchUsers = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/company/users`, {
            companyId: company?.id,
            year: company.year,
        }).then((res) => {
            let users = res.data.data;

            users.forEach((d, i) => {
                d.no = ++i;
                d.name = d.firstName + " " + d.lastName;
                delete d.permissions;
            });
            setUserData([...users]);
        }).catch((err) => {
            console.log(err);
            setUserData([]);
        });
    };

    const fetchCompanyData = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/details/${company.id}`, {
            headers: {'Content-Type': 'application/json'},
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                setCompanyData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const fetchCompanyTaxisCredentials = async () => {
        setCompanyCredsFetching(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/get-taxisnet-company-credentials`, {
                headers: {"Content-Type": "application/json"},
                params: {company: company.id}
            });

            if (res.data && res.data.status === "200" && res.data.data) {
                setCompanyCredentials({
                    username: res.data.data.username || "",
                    password: res.data.data.password || ""
                });
            }
        } catch (err) {
            console.error("Σφάλμα κατά την ανάκτηση στοιχείων Taxisnet εταιρείας:", err);
        } finally {
            setCompanyCredsFetching(false);
        }
    };

    const handleSaveCompanyCredentials = () => {
        setCompanyCredsLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/save-taxisnet-company-credentials`, {
            company: company.id,
            accountingCompanyCredentials: {
                username: companyCredentials.username.trim(),
                password: companyCredentials.password
            }
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setCompanyCredsLoading(false);
            if (res.data && res.data.status === "200") {
                toast.success(res.data.message || "Τα στοιχεία Taxisnet της εταιρείας αποθηκεύτηκαν επιτυχώς.");
            } else {
                toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση.");
            }
        }).catch((err) => {
            setCompanyCredsLoading(false);
            toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
            console.error(err);
        });
    };

    const resolveDefaultAccountantAfm = async () => {
        const envUrl1 = process.env.REACT_APP_API_URL || "";
        const envUrl2 = process.env.REACT_APP_API_URL2 || "";
        const hostname = typeof window !== "undefined" ? window.location.hostname : "";

        const isEmronEnv = envUrl1.includes("emron.gr") ||
            envUrl2.includes("emron.gr") ||
            hostname.includes("emron.gr");

        if (isEmronEnv) {
            return "800434990";
        }

        const primaryCompanyId = companyDetails?.primaryCompany || company?.primaryCompany;
        if (primaryCompanyId && String(primaryCompanyId).length === 24) {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL2}/company/get-company-vat-number`, {
                    headers: {"Content-Type": "application/json"},
                    params: {companyId: primaryCompanyId}
                });

                if (res.data && res.data.status === "200" && res.data.data?.vatNumber) {
                    return String(res.data.data.vatNumber).trim();
                }
            } catch (err) {
                console.error("Σφάλμα κατά την ανάκτηση ΑΦΜ primaryCompany:", err);
            }
        }

        return "";
    };

    const fetchAccountantTaxisCredentials = async () => {
        setAccountantCredsFetching(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/get-taxisnet-credentials`, {
                headers: {"Content-Type": "application/json"},
                params: {company: company.id}
            });

            if (res.data && res.data.status === "200" && res.data.data) {
                let savedAfm = res.data.data.accountantAfm || "";
                if (!savedAfm) {
                    savedAfm = await resolveDefaultAccountantAfm();
                }

                setAccountantCredentials({
                    username: res.data.data.username || "",
                    password: res.data.data.password || "",
                    isAccountant: Boolean(res.data.data.isAccountant),
                    accountantAfm: savedAfm
                });
            } else {
                const defaultAfm = await resolveDefaultAccountantAfm();
                setAccountantCredentials((prev) => ({
                    ...prev,
                    accountantAfm: defaultAfm
                }));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setAccountantCredsFetching(false);
        }
    };

    const handleAccountantCheckboxChange = async (checked) => {
        let updatedAfm = accountantCredentials.accountantAfm;
        if (checked && !updatedAfm) {
            updatedAfm = await resolveDefaultAccountantAfm();
        }

        setAccountantCredentials({
            ...accountantCredentials,
            isAccountant: checked,
            accountantAfm: updatedAfm
        });
    };

    const getAfmErrorMessage = (afm) => {
        if (!afm) return "";
        if (!/^\d+$/.test(afm)) {
            return "Αυτό που εισάγετε δεν είναι αριθμός";
        }
        if (String(afm).length !== 9) {
            return "Τα ψηφία του ΑΦΜ πρέπει να είναι 9 αριθμοί";
        }
        if (typeof validateAFM === "function" && !validateAFM(afm)) {
            return "Το Α.Φ.Μ. δεν είναι έγκυρο";
        }
        return "";
    };

    const isAfmValid = accountantCredentials.accountantAfm
        ? (typeof validateAFM === "function" ? validateAFM(accountantCredentials.accountantAfm) : accountantCredentials.accountantAfm.length === 9)
        : false;
    const afmErrorMessage = getAfmErrorMessage(accountantCredentials.accountantAfm);

    const handleSaveAccountantCredentials = () => {
        if (accountantCredentials.isAccountant && !isAfmValid) {
            toast.error(afmErrorMessage || "Παρακαλώ εισάγετε έγκυρο Α.Φ.Μ.");
            return;
        }

        setAccountantCredsLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/save-taxisnet-credentials`, {
            company: company.id,
            accountingTaxisnetCredentials: {
                username: accountantCredentials.username.trim(),
                password: accountantCredentials.password,
                isAccountant: accountantCredentials.isAccountant,
                accountantAfm: accountantCredentials.isAccountant ? accountantCredentials.accountantAfm.trim() : ""
            }
        }, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setAccountantCredsLoading(false);
            if (res.data && res.data.status === "200") {
                toast.success(res.data.message || "Τα στοιχεία Taxisnet αποθηκεύτηκαν επιτυχώς.");
            } else {
                toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση.");
            }
        }).catch((err) => {
            setAccountantCredsLoading(false);
            toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
            console.error(err);
        });
    };

    const installationsColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "5%",
        },
        {
            name: t('GeneralSettings.tableClientInstallations.type'),
            field: "type",
            editable: false,
            width: "10%",
            inputType: {
                type: "dropdown",
                config: {
                    searchEnable: true,
                },
            },
        },
        {
            name: t('GeneralSettings.tableClientInstallations.address'),
            field: "address",
            width: "15%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('GeneralSettings.tableClientInstallations.doy'),
            field: "doy",
            editable: false,
            width: "15%",
            inputType: {
                type: "dropdown",
                config: {
                    searchEnable: true,
                },
            },
        },
        {
            name: t('GeneralSettings.tableClientInstallations.city'),
            field: "city",
            width: "15%",
            editable: false,
            inputType: {
                type: "text",
                config: {
                    searchEnable: true,
                },
            },
        },
        {
            name: t('GeneralSettings.tableClientInstallations.postalCode'),
            field: "postalCode",
            editable: false,
            width: "10%",
            inputType: {
                type: "text",
                config: {
                    searchEnable: true,
                },
            },
        },
        {
            name: "Κατάσταση",
            field: "isActive",
            editable: false,
            width: "10%",
            inputType: {
                type: "input",
            }
        },
        {
            name: "Πρόθεμα Εγκατάστασης Λογιστικής",
            field: "installationAccounting",
            editable: true,
            hiddenColumn: !checkPermission("accounting-settings/accounting-read", permissionsData),
            width: "5%",
            inputType: {
                type: "input",
            }
        },
        {
            name: "Πρόθεμα Μετρητών Λογιστικής",
            field: "cashAccounting",
            editable: true,
            hiddenColumn: !checkPermission("accounting-settings/accounting-read", permissionsData),
            width: "5%",
            inputType: {
                type: "input",
            }
        },
        {
            name: "Ενέργειες",
            field: "installationActions",
            editable: false,
            width: "5%",
            inputType: {
                type: "input",
                editInstallationClicked: (rowData) => handleOpenEditInstallationModal(rowData)
            }
        }
    ];

    const companyUsersColumns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            width: "10%",
        },
        {
            name: t('GeneralSettings.tableCompanyUser.firstName'),
            field: "firstName",
            editable: false,
            width: "20%",
            inputType: {
                type: "text",
            },
        },
        {
            name: t('GeneralSettings.tableCompanyUser.lastName'),
            field: "lastName",
            editable: false,
            width: "20%",
            inputType: {
                type: "text",
            },
        },
        {
            name: t('GeneralSettings.tableCompanyUser.email'),
            field: "email",
            width: "20%",
            editable: false,
            inputType: {
                type: "text",
            },
        },
        {
            name: t('GeneralSettings.tableCompanyUser.username'),
            field: "userName",
            editable: false,
            width: "20%",
            inputType: {
                type: "text",
            },
        },
    ];

    const installationTableActions = {
        update: (data, id) => {
            if (data.installationAccounting !== undefined) {
                let cloneInstallations = [...installations];
                cloneInstallations = cloneInstallations.map((o) => Object.assign({}, o));
                const findMatching = cloneInstallations.find((el) => el._id === id);
                if (findMatching) {
                    findMatching.installationAccounting = data.installationAccounting;
                }
                dispatch(setCompanyInstallations(cloneInstallations));
            } else if (data.cashAccounting !== undefined) {
                let cloneInstallations = [...installations];
                cloneInstallations = cloneInstallations.map((o) => Object.assign({}, o));
                const findMatching = cloneInstallations.find((el) => el._id === id);
                if (findMatching) {
                    findMatching.cashAccounting = data.cashAccounting;
                }
                dispatch(setCompanyInstallations(cloneInstallations));
            }
        },
        selected: () => {
        }
    };

    const handleSaveAccounting = () => {
        if (installations?.length > 0) {
            axios.post(process.env.REACT_APP_API_URL2 + "/accounting/update-cash-installation-accounting", {
                installations: installations,
                company: company.id
            }, {
                headers: {"Content-Type": "application/json"},
            }).then((res) => {
                if (res.data.status === "200") {
                    toast.success("Η αποθήκευση έγινε με επιτυχία.");
                    dispatch(setCompanyInstallations(res.data.data));
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                console.log(err);
            });
        }
    };

    const handleOnChange = (e, type = "default", name = "") => {
        let key = name;
        let value;
        if (type === "default") {
            key = e.target.name;
            value = e.target.value;
        }
        if (key === "capital") {
            let cloneStockHolders = recalculateStockHolders(companyDetails.stockholders, Number(value));
            dispatch(setCompanyDetails({...companyDetails, [key]: value, stockholders: cloneStockHolders}));
        } else {
            dispatch(setCompanyDetails({...companyDetails, [key]: value}));
        }
    };

    const handleSaveStockholders = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/company/updateCompanyStockholders`, {
            company: company.id,
            vatNumber: company.vatNumber,
            stockholders: companyDetails.stockholders,
            capital: companyDetails.capital,
            sharesOut: companyDetails.sharesOut
        }, {
            headers: {'Content-Type': 'application/json'},
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Η αποθήκευση έγινε επιτυχώς.");
                dispatch(fetchCompanyDetails(company.id));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    };

    const newStockHolderInitialValue = {
        no: "",
        id: "",
        name: "",
        surname: "",
        vat: "",
        position: "",
        percentage: "0",
        stockValue: 0,
        dateFrom: "",
        dateTo: "",
        isActive: "true",
    };

    const stockholdersTableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value)) {
                let cloneStockHolders = [];
                if (companyDetails?.stockholders) cloneStockHolders = structuredClone(companyDetails.stockholders);

                const newRow = structuredClone(newStockHolderInitialValue);
                newRow["id"] = String(cloneStockHolders.length + 1);
                newRow["no"] = String(cloneStockHolders.length + 1);
                newRow[data.field] = data.value;
                cloneStockHolders.push(newRow);
                cloneStockHolders = recalculateStockHolders(cloneStockHolders, companyDetails.capital);
                dispatch(setCompanyDetails({...companyDetails, stockholders: cloneStockHolders}));
            }
        },
        update: (data, id, rowIndex) => {
            if (rowIndex >= 0) {
                if (data.percentage) {
                    if (parseFloat(data.percentage) < 0 || parseFloat(data.percentage) > 100 || isNaN(data.percentage)) {
                        dispatch(setCompanyDetails({...companyDetails}));
                        toast.error("Stockholder percentage must be a number from 0 to 100");
                        return;
                    }
                }
                if (data.percentage && isEmpty(data.percentage)) data.percentage = "0";
                if (data.percentage && !isEmpty(data.percentage)) data.percentage = parseFloat(data.percentage).toFixed(2);

                let cloneStockHolders = structuredClone(companyDetails.stockholders);
                cloneStockHolders[rowIndex] = {...cloneStockHolders[rowIndex], ...data};
                cloneStockHolders = recalculateStockHolders(cloneStockHolders, companyDetails.capital);
                dispatch(setCompanyDetails({...companyDetails, stockholders: cloneStockHolders}));
            }
        },
        selected: () => {
        },
        delete: (id, rowIndex) => {
            if (companyDetails.stockholders[rowIndex]._id) {
                axios.get(`${process.env.REACT_APP_API_URL2}/accounting/stockholder-deletable`, {
                    headers: {"Content-Type": "application/json"},
                    params: {
                        company: company.id,
                        stockholderId: companyDetails.stockholders[rowIndex]._id,
                    }
                }).then((res) => {
                    if (res.data.status === "200") {
                        let cloneStockHolders = structuredClone(companyDetails.stockholders);
                        cloneStockHolders.splice(rowIndex, 1);
                        cloneStockHolders = recalculateStockHolders(cloneStockHolders, companyDetails.capital);
                        dispatch(setCompanyDetails({...companyDetails, stockholders: cloneStockHolders}));
                    } else {
                        toast.error("Ο μέτοχος δεν μπορεί να διαγραφεί διότι χρησιμοποιείται σε κάποια λογιστική εγγραφή.");
                    }
                }).catch((err) => {
                    console.log(err);
                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                });
            } else {
                if (rowIndex >= 0) {
                    let cloneStockHolders = structuredClone(companyDetails.stockholders);
                    cloneStockHolders.splice(rowIndex, 1);
                    cloneStockHolders = recalculateStockHolders(cloneStockHolders, companyDetails.capital);
                    dispatch(setCompanyDetails({...companyDetails, stockholders: cloneStockHolders}));
                }
            }
        }
    };

    const handleOnChangeInstallation = (modalType, e, type, name) => {
        let cloneObj = modalType === "new" ? structuredClone(newInstallation) : structuredClone(editInstallation);

        if (type === "input") {
            cloneObj[name] = e.target.value;
        } else if (type === "dropdown") {
            if (name === "installationMasterId") {
                cloneObj["installationMasterId"] = e.value;
                cloneObj["type"] = e.label;
            } else if (name === "doy") {
                cloneObj["doy"] = e.label;
            } else {
                cloneObj[name] = e.value;
            }
        }

        if (modalType === "new") {
            setNewInstallation(cloneObj);
        } else {
            setEditInstallation(cloneObj);
        }
    };

    const handleAddNewInstallation = () => {
        setNewInstallationLoading(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/company/add-installation-from-erp", newInstallation, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setNewInstallationLoading(false);
            if (res.data.status === "200") {
                toast.success("Η εγκατάσταση προστέθηκε επιτυχώς.");
                dispatch(fetchCompanyInstallations(company.id));
                setNewInstallation(initNewInstallation);
                setShowNewInstallationModal(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setNewInstallationLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    };

    const newInstallationInvalid = () => {
        return isEmpty(newInstallation.address) || isEmpty(newInstallation.city) || isEmpty(newInstallation.postalCode)
            || isEmpty(newInstallation.doy) || isEmpty(newInstallation.phone);
    };

    const handleEditInstallation = () => {
        setEditInstallationLoading(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/company/edit-installation-from-erp", editInstallation, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setEditInstallationLoading(false);
            if (res.data.status === "200") {
                toast.success("Η εγκατάσταση τροποποιήθηκε επιτυχώς.");
                dispatch(fetchCompanyInstallations(company.id));
                setEditInstallation({});
                setShowEditInstallationModal(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setEditInstallationLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    };

    const editInstallationInvalid = () => {
        return isEmpty(editInstallation.address) || isEmpty(editInstallation.city) || isEmpty(editInstallation.postalCode)
            || isEmpty(editInstallation.doy) || isEmpty(editInstallation.phone);
    };

    const handleOpenEditInstallationModal = (rowData) => {
        setShowEditInstallationModal(true);
        setEditInstallation({...rowData});
    };

    return (
        <React.Fragment>
            <style>{`
                #isAccountantCheckbox:checked ~ .custom-control-label::before {
                    background-color: #76AEB7 !important;
                    border-color: #76AEB7 !important;
                }
                #isAccountantCheckbox:focus ~ .custom-control-label::before {
                    box-shadow: 0 0 0 0.2rem rgba(118, 174, 183, 0.25) !important;
                }
            `}</style>

            <Row>
                <Col md={6}>
                    <div className="csettings-company-card">
                        <div className="csettings-card-header">
                            <h2>Στοιχεία Επιχείρησης</h2>
                        </div>

                        <div className="csettings-card-grid">
                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.companyName.companyName')}</label>
                                <p className="csettings-data-value">{companyData?.name}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.companySmallName.companySmallName')}</label>
                                <p className="csettings-data-value">{companyData?.smallName}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.activity.activity')}</label>
                                <p className="csettings-data-value">{companyData?.activity}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.vatNumber.vatNumber')}</label>
                                <p className="csettings-data-value">{companyData?.vatNumber}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>ΔΟΥ</label>
                                <p className="csettings-data-value">{companyData?.doy}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.headquartersAddress.headquartersAddress')}</label>
                                <p className="csettings-data-value">{companyData?.headquartersAddress}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.city.city')}</label>
                                <p className="csettings-data-value">{companyData?.city}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.country.country')}</label>
                                <p className="csettings-data-value">{companyData?.country}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.postalCode.postalCode')}</label>
                                <p className="csettings-data-value">{companyData?.postalCode}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.phoneNumber.phoneNumber')}</label>
                                <p className="csettings-data-value">{companyData?.phone || "-"}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.email.email')}</label>
                                <p className="csettings-data-value">{companyData?.email || "-"}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.gemh.gemh')}</label>
                                <p className="csettings-data-value">{companyData?.gemhNo || "-"}</p>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="csettings-company-card mb-3">
                        <div className="csettings-card-header">
                            <h2>Στοιχεία Νόμιμου Εκπροσώπου</h2>
                        </div>

                        <div className="csettings-card-grid">
                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.representativeName.representativeName')}</label>
                                <p className="csettings-data-value">{companyData?.representativeName}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.representativeSurname.representativeSurname')}</label>
                                <p className="csettings-data-value">{companyData?.representativeSurname}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.representativeVatNumber.representativeVatNumber')}</label>
                                <p className="csettings-data-value">{companyData?.representativeVatNumber}</p>
                            </div>
                        </div>
                    </div>
                    <div className="csettings-company-card">
                        <div className="csettings-card-header">
                            <h2>Λοιπά Δεδομένα</h2>
                        </div>

                        <div className="csettings-card-grid">
                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.companyStartDate')}</label>
                                <p className="csettings-data-value">{moment(companyData?.companyEstablishedDate).format("DD/MM/YYYY")}</p>
                            </div>

                            <div className="csettings-info-group">
                                <label>{t('GeneralSettings.companyExpireDate')}</label>
                                <p className="csettings-data-value">{moment(companyData?.companyExpireDate).format("DD/MM/YYYY")}</p>
                            </div>
                        </div>

                        <div>
                            <label style={{color: "#64748b"}}>{t('GeneralSettings.companyLogo')}</label>
                            <Row>
                                <Col md={6}>
                                    {imgData && (
                                        <div>
                                            <img src={imgData} alt="Company Logo" width="250"/>

                                            <Checkbox
                                                className="w-100 sendEmailOnSave mt-1"
                                                text={t('GeneralSettings.useLogoInInvoices')}
                                                name="useLogo"
                                                key={Math.random()}
                                                defaultValue={useLogo === "active"}
                                                value={useLogo === "active" ? "inactive" : "active"}
                                                onChange={(e) => handleUseLogo(e)}
                                            />
                                        </div>
                                    )}
                                </Col>
                                <Col md={6}>
                                    <input type={"file"} style={{display: "none"}} id={"filesInput"}
                                           onChange={(e) => uploadCompanyLogo(e)}/>
                                    {checkPermission("settings-generalsettings/companysettings-write", permissionsData) && (
                                        <Button id="upload-button"
                                                onClick={() => document.getElementById("filesInput").click()}>{t('GeneralSettings.uploadFile')}</Button>
                                    )}
                                    <div className="text-muted mb-2">
                                        <i>{t('GeneralSettings.uploadFileDesc')}</i>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>

            <div className="csettings-company-card p-3 mt-3">
                <div className="csettings-card-header">
                    <h2>Εγκαταστάσεις</h2>
                </div>
                <div className={"p-0"}>
                    <Row>
                        <Col md={12}>
                            <EditableTable
                                key={Math.random()}
                                tableName="Company Installations List"
                                columns={installationsColumns}
                                data={installations}
                                onUpdate={installationTableActions}
                            />
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={3}>
                            <Button size={"sm"} onClick={() => setShowNewInstallationModal(true)}>+ Προσθήκη
                                εγκατάστασης</Button>
                        </Col>
                        {checkPermission("accounting-settings/accounting-read", permissionsData) && (
                            <Col md={9}>
                                <Button size={"sm"} style={{float: "right"}}
                                        onClick={() => handleSaveAccounting()}><FaSave/> Αποθήκευση λογιστικών
                                    προθεμάτων</Button>
                            </Col>
                        )}
                    </Row>
                </div>
            </div>

            <div className="csettings-company-card p-3 mt-3">
                <div className="csettings-card-header">
                    <h2>{t('GeneralSettings.companyUsers')}</h2>
                </div>
                <div className={"p-0"}>
                    <EditableTable
                        tableName="Company Users List"
                        key={userDataIncrKey}
                        columns={companyUsersColumns}
                        data={userData}
                        className="mb-2"
                    />
                </div>
            </div>

            <div className="csettings-company-card p-3 mb-3 mt-3">
                <div className="csettings-card-header">
                    <h2>Μέτοχοι</h2>
                </div>
                <div className={"p-0"}>
                    <Row className={"mb-2"}>
                        <Col md={3}>
                            <Input
                                name={"capital"}
                                type={"number"}
                                label={"Κεφάλαιο Επιχείρησης (€)"}
                                value={companyDetails?.capital}
                                autoComplete={"off"}
                                placeholder={"Κεφάλαιο Επιχείρησης (€)"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={3}>
                            <Input
                                name={"sharesOut"}
                                type={"number"}
                                label={"Αριθμός Μετοχών"}
                                value={companyDetails?.sharesOut}
                                autoComplete={"off"}
                                placeholder={"Συνολικός αριθμός μετοχών"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <EditableTable
                                tableName="Company Stock Holders"
                                actionButtons={{
                                    print: false,
                                    delete: true,
                                    export: false,
                                    edit: false,
                                }}
                                key={Math.random()}
                                allowActions={true}
                                columns={stockHoldersTableColumns}
                                data={companyDetails?.stockholders ? companyDetails?.stockholders : []}
                                allowInsertRow={true}
                                onUpdate={stockholdersTableFunctions}
                            />
                        </Col>
                    </Row>
                    {(stockHolderPercentageDiff(companyDetails?.stockholders) !== 0 && companyDetails?.stockholders?.length > 0) && (
                        <Row>
                            <Col md={6}>
                                <span style={{color: "red"}}>Οι μέτοχοι πρέπει αθροιστικά να έχουν ποσοστό 100%, απόκλιση: {stockHolderPercentageDiff(companyDetails?.stockholders)} %</span>
                            </Col>
                        </Row>
                    )}
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <Button size={"sm"} style={{float: "right"}}
                                    onClick={() => handleSaveStockholders()}><FaSave/> Αποθήκευση αλλαγών
                                μετόχων</Button>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="csettings-company-card p-3 mb-4 mt-3">
                <div className="csettings-card-header">
                    <h2>Κωδικοί Taxisnet</h2>
                </div>

                <Row>
                    <Col lg={6} className="mb-3 mb-lg-0 border-right">
                        <h5 className="font-weight-bold text-dark mb-4">Στοιχεία Σύνδεσης Taxisnet Εταιρείας (Νομικό Πρόσωπο)</h5>

                        <div className="form-group mb-3">
                            <label className="font-weight-bold mb-1" style={{fontSize: "0.85rem"}}>
                                Όνομα Χρήστη (Username)
                            </label>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Username εταιρείας στο Taxisnet"
                                value={companyCredentials.username}
                                onChange={(e) => setCompanyCredentials({
                                    ...companyCredentials,
                                    username: e.target.value
                                })}
                                disabled={companyCredsFetching}
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label className="font-weight-bold mb-1" style={{ fontSize: "0.85rem" }}>
                                Συνθηματικό (Password)
                            </label>
                            <SecureMaskedPasswordInput
                                size="sm"
                                placeholder="Password"
                                value={companyCredentials.password}
                                onChange={(newPassword) => setCompanyCredentials({ ...companyCredentials, password: newPassword })}
                                disabled={companyCredsFetching}
                            />
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                            <Button
                                size="sm"
                                variant="primary"
                                onClick={handleSaveCompanyCredentials}
                                disabled={companyCredsLoading || companyCredsFetching}
                            >
                                {companyCredsLoading ? "Αποθήκευση..." : <><FaSave className="mr-1"/> Αποθήκευση Στοιχείων</>}
                            </Button>
                        </div>
                    </Col>

                    <Col lg={6}>
                        <h5 className="font-weight-bold text-dark mb-4">Στοιχεία σύνδεσης Taxisnet για Έντυπα (Φυσικό Πρόσωπο)</h5>

                        <div className="form-group mb-3">
                            <label className="font-weight-bold mb-1" style={{fontSize: "0.85rem"}}>
                                Όνομα Χρήστη (Username)
                            </label>
                            <Form.Control
                                size="sm"
                                type="text"
                                placeholder="Username λογιστή ή εκπροσώπου"
                                value={accountantCredentials.username}
                                onChange={(e) => setAccountantCredentials({
                                    ...accountantCredentials,
                                    username: e.target.value
                                })}
                                disabled={accountantCredsFetching}
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label className="font-weight-bold mb-1" style={{ fontSize: "0.85rem" }}>
                                Συνθηματικό (Password)
                            </label>
                            <SecureMaskedPasswordInput
                                size="sm"
                                placeholder="Password"
                                value={accountantCredentials.password}
                                onChange={(newPassword) => setAccountantCredentials({ ...accountantCredentials, password: newPassword })}
                                disabled={accountantCredsFetching}
                            />
                        </div>

                        <div className="custom-control custom-checkbox mt-2 mb-2">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="isAccountantCheckbox"
                                checked={accountantCredentials.isAccountant}
                                onChange={(e) => handleAccountantCheckboxChange(e.target.checked)}
                                disabled={accountantCredsFetching}
                            />
                            <label
                                className="custom-control-label font-weight-bold text-dark"
                                htmlFor="isAccountantCheckbox"
                                style={{cursor: "pointer", fontSize: "0.85rem", paddingTop: "2px"}}
                            >
                                Είσοδος ως λογιστής
                            </label>
                        </div>

                        {accountantCredentials.isAccountant && (
                            <div className="form-group mt-3">
                                <label className="font-weight-bold mb-1" style={{fontSize: "0.85rem"}}>
                                    Α.Φ.Μ. Λογιστή / Λογιστικού Γραφείου
                                </label>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    maxLength={9}
                                    placeholder="9-ψήφιος αριθμός ΑΦΜ"
                                    value={accountantCredentials.accountantAfm}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, "");
                                        setAccountantCredentials({...accountantCredentials, accountantAfm: val});
                                    }}
                                    isInvalid={Boolean(accountantCredentials.accountantAfm && !isAfmValid)}
                                    disabled={accountantCredsFetching}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {afmErrorMessage}
                                </Form.Control.Feedback>
                            </div>
                        )}

                        <div className="d-flex justify-content-end mt-4">
                            <Button
                                size="sm"
                                variant="primary"
                                onClick={handleSaveAccountantCredentials}
                                disabled={accountantCredsLoading || accountantCredsFetching || (accountantCredentials.isAccountant && !isAfmValid)}
                            >
                                {accountantCredsLoading ? "Αποθήκευση..." : <><FaSave className="mr-1"/> Αποθήκευση Στοιχείων</>}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>

            <Modal backdrop={"static"} show={showNewInstallationModal}
                   onHide={() => setShowNewInstallationModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Προσθήκη νέας εγκατάστασης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown
                        name={"installationMasterId"}
                        label={"Τύπος εγκατάστασης"}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === newInstallation.installationMasterId)}
                        key={Math.random()}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "dropdown", "installationMasterId")}
                    />
                    <Dropdown
                        name={"isActive"}
                        label={"Κατάσταση εγκατάστασης"}
                        options={activityOptions}
                        defaultValue={activityOptions.find((el) => el.value === newInstallation.isActive)}
                        key={Math.random()}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "dropdown", "isActive")}
                    />
                    <Input
                        name={"city"}
                        label={"Πόλη"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={newInstallation.city}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "input", "city")}
                    />
                    <Input
                        name={"address"}
                        label={"Διεύθυνση"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={newInstallation.address}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "input", "address")}
                    />
                    <Input
                        className={"mb-2"}
                        name={"postalCode"}
                        label={"Τ.Κ."}
                        autoComplete={"off"}
                        value={newInstallation.postalCode}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "input", "postalCode")}
                    />
                    <Dropdown
                        name={"doy"}
                        label={"Δ.Ο.Υ."}
                        options={getDOYOptions()}
                        defaultValue={getDOYOptions().find((el) => el.label === newInstallation.doy) ? getDOYOptions().find((el) => el.label === newInstallation.doy) : ""}
                        key={Math.random()}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "dropdown", "doy")}
                    />
                    <Input
                        name={"phone"}
                        label={"Τηλέφωνο"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={newInstallation.phone}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("new", e, "input", "phone")}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowNewInstallationModal(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleAddNewInstallation()}
                            disabled={newInstallationInvalid() || newInstallationLoading}>
                        Προσθήκη {newInstallationLoading &&
                        <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showEditInstallationModal} onHide={() => setShowEditInstallationModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Τροποποίηση εγκατάστασης</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown
                        name={"installationMasterId"}
                        label={"Τύπος εγκατάστασης"}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === editInstallation.installationMasterId)}
                        key={Math.random()}
                        required={true}
                        disabled={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "dropdown", "installationMasterId")}
                    />
                    <Dropdown
                        name={"isActive"}
                        label={"Κατάσταση εγκατάστασης"}
                        options={activityOptions}
                        defaultValue={activityOptions.find((el) => el.value === editInstallation.isActive)}
                        key={Math.random()}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "dropdown", "isActive")}
                    />
                    <Input
                        name={"city"}
                        label={"Πόλη"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={editInstallation.city}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "input", "city")}
                    />
                    <Input
                        name={"address"}
                        label={"Διεύθυνση"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={editInstallation.address}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "input", "address")}
                    />
                    <Input
                        name={"postalCode"}
                        label={"Τ.Κ."}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={editInstallation.postalCode}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "input", "postalCode")}
                    />
                    <Dropdown
                        name={"doy"}
                        label={"Δ.Ο.Υ."}
                        options={getDOYOptions()}
                        defaultValue={getDOYOptions().find((el) => el.label === editInstallation.doy) ? getDOYOptions().find((el) => el.label === editInstallation.doy) : ""}
                        key={Math.random()}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "dropdown", "doy")}
                    />
                    <Input
                        name={"phone"}
                        label={"Τηλέφωνο"}
                        className={"mb-2"}
                        autoComplete={"off"}
                        value={editInstallation.phone}
                        required={true}
                        onChange={(e) => handleOnChangeInstallation("edit", e, "input", "phone")}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowEditInstallationModal(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleEditInstallation()}
                            disabled={editInstallationInvalid() || editInstallationLoading}>
                        Τροποποίηση {editInstallationLoading &&
                        <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
};

export default CompanySettings;